import BrowserBaseApp from './browserBaseApp';

export default BrowserBaseApp;
